import React from "react";
import ButtonBasic from "./ButtonBasic";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

const ButtonCreate = ({ label, id, cypressid, style: userStyles = {}, ...props }) => {
  return (
    <React.Fragment>
      <ButtonBasic label={label} id={id} style={userStyles} cypressid={cypressid} {...props}>
        <FontAwesomeIcon className='font-icon' icon={faPlus} />
      </ButtonBasic>
    </React.Fragment>
  );
};

ButtonCreate.defaultProps = {
  label: "Add",
  cypressid: "create"
};

export default ButtonCreate;
